import React from 'react';
import useGTMIntegrationWithConfig from '../../hooks/script-integrations/useGTMIntegrationWithConfig';
import useGAIntegrationWithConfig from '../../hooks/script-integrations/useGAIntegrationWithConfig';
import useHighAdvocacyIntegrationWithConfig from '../../hooks/script-integrations/useHighAdvocacyIntegrationWithConfig';
import useCelloIntegrationWithConfig from '../../hooks/script-integrations/useCelloIntegration';
import useChurnKeyIntegrationWithConfig from '../../hooks/script-integrations/useChurnKeyIntegrationWithConfig';
import useBetterBugsIntegrationWithConfig from '../../hooks/script-integrations/useBetterBugsIntegrationWithConfig';
import { ThirdPartyIntegrationsProps } from './type';
import usePaddleIntegrationWithConfig from '../../hooks/script-integrations/usePaddleIntegrationWithConfig';

const ThirdPartyIntegrations: React.FC<ThirdPartyIntegrationsProps> = ({
  enableGTM = true,
  enableGA = true,
  enableHighAdvocacy = true,
  enableCello = true,
  enableChurnKey = true,
  enableBetterBugs = true,
  enablePaddle = true,
  onGTMError = () => { },
  onCelloError = () => { },
  onChurnKeyError = () => { },
  onBetterBugsError = () => {},
  onPaddleError = () => { },
  onHighAdvocacyError = () => { },
  onGAError,
}) => {
  // For GTM integration
  useGTMIntegrationWithConfig({
    enable: enableGTM,
    onError: onGTMError,
  });

  // For Google Analytics integration
  useGAIntegrationWithConfig({
    enable: enableGA,
    onError: onGAError,
  });

  // For HighAdvocacy integration
  useHighAdvocacyIntegrationWithConfig({
    enable: enableHighAdvocacy,
    onError: onHighAdvocacyError,
  });

  // For Cello integration
  useCelloIntegrationWithConfig({
    enable: enableCello,
    onError: onCelloError,
  });

  // For ChurnKey integration
  useChurnKeyIntegrationWithConfig({
    enable: enableChurnKey,
    onError: onChurnKeyError,
  });

  // For BetterBugs integration
  useBetterBugsIntegrationWithConfig({
    enable: enableBetterBugs,
    onError: onBetterBugsError,
  });
  
  // For Paddle integration
  usePaddleIntegrationWithConfig({
    enable: enablePaddle,
    onError: onPaddleError,
  });

  // This component doesn't render anything visible
  return null;
};

export default ThirdPartyIntegrations;
